module.exports = __webpack_public_path__ + "static/media/browser.9ecf9037.svg";